type Props = {
    img: string
    link: string
    style?: React.CSSProperties
}

export function Pub({ img, link, style }: Props) {
    return (
        <div style={{ ...style }}>
            <a href={link}>
                <img style={{ height: "100%", width: "100%" }} src={img} alt="" />
            </a>
        </div>
    )
}